import { toastsMutations } from "../mutation-types";

const defaults = {
	color: "success",
	text: null,
	timeout: null
};

const durations = {
	LENGTH_SHORT: 5000,
	LENGTH_LONG: 10000
};

export default {
	namespaced: true,

	state: {
		toast: {
			color: defaults.color,
			text: defaults.text,
			timeout: defaults.timeout,
			visible: false
		}
	},

	mutations: {
		[toastsMutations.SHOW]( state, payload ) {
			const settings = Object.assign( {}, defaults, payload );

			if ( settings.timeout && durations.hasOwnProperty( settings.timeout ) ) {
				settings.timeout = durations[settings.timeout];
			} else if ( !settings.timeout ) {
				settings.timeout = durations[settings.color === "error" ? "LENGTH_LONG" : "LENGTH_SHORT"];
			}

			state.toast.color = settings.color;
			state.toast.text = settings.text;
			state.toast.timeout = settings.timeout;
			state.toast.visible = true;
		},

		[toastsMutations.REMOVE]( state ) {
			state.toast.color = defaults.color;
			state.toast.text = defaults.text;
			state.toast.timeout = defaults.timeout;
			state.toast.visible = false;
		}
	}
};
